import Grid from '@material-ui/core/Grid'
import DatePicker from 'Components/DatePicker'
import Input from 'Components/Input'
import Modal from 'Components/Modal'
import Search from 'Components/Search'
import Select from 'Components/Select'
import ApiRequest from 'EurestoApi/ApiRequest'
import User from 'EurestoClass/User'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import Utils from 'EurestoFonction/Utils'
import React from 'react'
import DataGrid from '../../../CRM/Component/Table'




class SearchClient extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      search: props.search,
      key: Utils.getRandomNumber(),
    }
  }

  search = async (data, name) => {
    const search = this.state.search


    if (name === '%date_creation') {
      if (data === '|' && !Array.isArray(search.date_creation)) {
        search.date_creation = [search.date_creation, search.date_creation]
      } else if (data !== '|' && Array.isArray(search.date_creation)) {
        search.date_creation = search.date_creation[0]
      }
    }

    search[name] = data
    this.setState({
      search: search,
    }, () => this.props.searching && this.props.searching(search))
  }

  async componentDidMount () {
    if (this.state.search.contact_id && this.state.libelle_client_contact === undefined) {
      this.getInfoContact(this.state.search.contact_id)
        .then(contact => {
          this.setState({
            libelle_client_contact: contact.libelle
          })
        })
    }
  }

  getInfoContact = async (id) => {
    const result = await ApiRequest(project.api + 'crm', {
      action: 'get',
      requete: 'client',
      id: id
    }, { showAlertError: false })
    return result.results
  }

  handleClickModalContact = (open) => {
    this.setState({
      showModalContact: open,
      keyModalDossier: Utils.getRandomNumber()
    })
  }

  onSelectContact = (row) => {
    this.setState({
      libelle_client_contact: row.libelle
    }, _ => {
      this.handleClickModalContact(false)
      this.search(row.id, 'contact_id')
    })
  }

  ModalContact = () => {
    return (
      this.state.showModalContact &&
      <Modal open={this.state.showModalContact} onClose={() => this.handleClickModalContact(false)} grid={{ xs: 8 }}>
        <EurestoDiv
          buttonsRight={[{
            icon: ' ei-commun_fermer',
            className: 'EurestoError--text EurestoText',
            cb: () => this.handleClickModalContact(false)
          }]}
          style={{
            margin: 0,
            padding: 10,
            maxHeight: User.CalculHeight.getHeightWanted(70),
            height: User.CalculHeight.getHeightWanted(70),
            overflowY: 'auto'
          }}>
          {
            <DataGrid onClick={this.onSelectContact} view={'list'} style={{
              maxHeight: User.CalculHeight.getHeightWanted(70),
            }} type="client" name={'sdd-'} showSearch={true}/>
          }
        </EurestoDiv>
      </Modal>
    )
  }

  render () {
    return (
      <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 5, overflow: 'visible' }} justify={'flex-start'}
            alignItems={'stretch'}
            alignContent={'flex-start'}
            direction={'column'}>

        <Input
          autoFocus={true}
          onChange={this.search}
          name="libelle"
          type="text"
          className="upText"
          value={this.state.search.libelle}
          title={EurestoI18n.t('crm:Intitulé Carte')}
        />
        <Input
          autoFocus={true}
          onChange={this.search}
          name="code_barres"
          type="text"
          className="upText"
          value={this.state.search.code_barres}
          title={EurestoI18n.t('crm:Code barres')}
        />
        <Input
          onClick={() => this.handleClickModalContact(true)}
          className="upText"
          title={'Client'}
          type="text"
          value={this.state.libelle_client_contact || ''}
          InputProps={{
            startAdornment: (
              <i style={{ zIndex: 3 }} className={'ei-commun_rechercher'}/>
            ),
            endAdornment: (
              this.state.search.contact_id &&
              <i onClick={(e) => e.stopPropagation() || this.setState({
                libelle_client_contact: undefined
              }, _ => this.search(undefined, 'contact_id'))}
                 style={{ zIndex: 3, marginRight: 7.5 }}
                 className={'ei-commun_fermer EurestoError--text cursor-pointer'}/>
            )
          }}
        />
        <Select
          title={EurestoI18n.t('reservation:Type de recherche')}
          name={'%date_creation'}
          value={this.state.search['%date_creation']}
          onChange={this.search}
          autoComplete={false}
          options={[{
            label: 'Créée après',
            value: '>'
          }, {
            label: 'Créée entre',
            value: '|'
          }, {
            label: 'Créée avant',
            value: '<'
          }]}
        />
        <DatePicker value={this.state.search['date_creation']}
                    range={this.state.search['%date_creation'] === '|'}
                    title={EurestoI18n.t('commun:Date Création')}
                    onChange={this.search}
                    name={'date_creation'}/>

        {
          this.ModalContact()
        }
      </Grid>
    )
  }

}


export default class extends React.Component {

  render () {
    return <Search raz={true} defaultSearch={this.props.defaultSearch} path={'fidelite'} requete={'carte'}
                   search={this.props.search || 'fidelite_' + (this.props.name || '') + User.Entite.get().id}>
      <SearchClient/>
    </Search>
  }

}



// WEBPACK FOOTER //
// ./app/App/Module/Fidelite/Component/Search/index.js